function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMagicWandFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.51 2.001L2 25.511l4.49 4.488L29.998 6.491 25.51 2zm1.85 4.49l-4.121 4.12-1.85-1.85 4.12-4.12 1.85 1.85zM4.64 25.51l15.429-15.43 1.85 1.851L6.49 27.36l-1.85-1.85zm.626-12.777H1.999v-1.867h3.267V7.6h1.867v3.267h3.266v1.867H7.133V16H5.266v-3.267zM30 23.934h-3.267v3.267h-1.867v-3.267h-3.267v-1.867h3.267V18.8h1.867v3.267H30v1.867zm-16.8-18.2h-1.867V3.866h1.866V2h1.867v1.867h1.867v1.866h-1.867V7.6h-1.867V5.733z",
    fill: props.color
  }));
}

export default SvgIconMagicWandFilled;